/**
 * Created by tomers on 7/20/2014.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/categories/categoriesGridRowView.tmpl");
    var Checkbox = require("ui/checkbox/Checkbox");
    var InlineInput = require("ui/inline-input/InlineInput");

    var CategoriesGridRowView = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        CategoriesGridRowView = Marionette.ItemView.extend({

            template: template,
            tagName: "tr",
            className: "campaign_row",
            ui:{
                selector: ".selector",
                order: ".ordering",
                name: ".name-input-container",
                proposedContainer: ".proposed-checkbox-container",
                assignedContent: ".assignedContent",
                assignedCampaigns: ".assignedCampaigns",
                actionButtonsContainer: ".actions-container",
                moveTopContainer: ".actions-movetop-container",
                moveUpContainer: ".actions-moveup-container",
                moveDownContainer: ".actions-movedown-container"
            },
            modelEvents: {
                "change:name": "updateName",
                "change:order": "updateOrder",
                "change:proposed": "updateProposed",
                "change:assignedContent": "updateAssignedContent",
                "change:assignedCampaigns": "updateAssignedCampaigns"
            },
            events:{
                "click .actions-movetop" : "onMoveTopClick",
                "click .actions-moveup" : "onMoveUpClick",
                "click .actions-movedown" : "onMoveDownClick"
            },
            uiComponents:{
                selectCheckBox:{
                    type: Checkbox,
                    options:{
                        el: "view.ui.selector",
                        permutation: Checkbox.PERMUTATION.B,
                        label: "",
                        checked: false,
                        enabled: "view.hasEditPrivileges"
                    },
                    events: {
                        change: "onRowSelect"
                    }
                },
                name: {
                    type: InlineInput,
                    options: {
                        permutation: InlineInput.PERMUTATION.H,
                        container: "view.ui.name",
                        value: "view._getCategoryName",
                        maxLength: "view.model.MAX_NAME_LENGTH",
                        enabled: "view.hasEditPrivileges"
                    },
                    events: {
                        change: "onNameInputChange",
                        blur: "onNameInputBlur"
                    }
                },
                proposedCheckBox: {
                    type: Checkbox,
                    options:{
                        el: "view.ui.proposedContainer",
                        permutation: Checkbox.PERMUTATION.BIG,
                        label: "",
                        checked: false,
                        enabled: "view.hasEditPrivileges"
                    },
                    events: {
                        change: "onProposedClick"
                    }
                }
            },

            initialize: function(options) {
                this.vent = options.vent;
                this.reqres = options.reqres;
                this.hasEditPrivileges = options.hasEditPrivileges;

                this.listenTo(this.vent, "categories:enableNavigation", this._enableNavigation);
            },

            customTemplateHelpers: function() {
                return {
                    hasEditPrivileges: this.hasEditPrivileges
                };
            },

            onRender: function() {

                this._bindCheckboxWrapperClick();

                this.updateName();
                this.updateOrder();
                this.updateProposed();
                this.updateAssignedContent();
                this.updateAssignedCampaigns();
            },

            updateName: function() {
                var name = this._getCategoryName();
                this.uiComponents.name.setError(false);
                this.uiComponents.name.setValue(name);
            },

            updateOrder: function() {
                var order = this.model.get(this.model.KEYS.ORDER);
                this.ui.order.text(order);
            },

            updateProposed: function() {
                var proposed = this.model.get(this.model.KEYS.PROPOSED);
                this.uiComponents.proposedCheckBox.setCheckedState(proposed);
            },

            updateAssignedContent: function() {
                var assignedContent = this.model.get(this.model.KEYS.ASSIGNED_CONTENT);
                this.ui.assignedContent.text(assignedContent);
            },

            updateAssignedCampaigns: function() {
                var assignedCampaigns = this.model.get(this.model.KEYS.ASSIGNED_CAMPAIGNS);
                this.ui.assignedCampaigns.text(assignedCampaigns);
            },

            /**
             * We want to mimic the click event on the checkbox wrapper as the user clicks on the checkbox
             * @private
             */
            _bindCheckboxWrapperClick: function() {
                this.ui.selector.on("click", _.bind(function (e) {
                    if ($(e.target).hasClass("selector")) {
                        this.uiComponents.selectCheckBox.checkboxClick();
                    }
                }, this));
            },


            onMoveUpClick: function() {
                this.vent.trigger("categoryTable:change:order:moveup", this, this.model);
            },

            onMoveTopClick: function() {
                this.vent.trigger("categoryTable:change:order:movetop", this, this.model);
            },

            onMoveDownClick: function() {
                this.vent.trigger("categoryTable:change:order:movedown", this, this.model);
            },

            onNameInputChange: function(componentId, eventName, value) {
                this.vent.trigger("categoryTable:change:name", this, this.model, value);
            },

            /**
             * This happens when there is an error from the server and the user enters the input (focus) and blur it without change it.
             * In this case the value in the model will be the last known good value, and the value in the ui will be the 'bad' value.
             * In this case we need to change the ui back to the last known good value.
             * The value from the model is the last known good value - handled by the controller
             * @param componentId
             * @param eventName
             * @param value
             */
            onNameInputBlur: function(componentId, eventName, value) {
                if (value !== this.model.getName()) {
                    this.uiComponents.name.setValue(this.model.getName());
                }
            },

            onProposedClick: function(componentId, eventName, isChecked) {
                this.vent.trigger("categoryTable:change:proposed", this, this.model, isChecked);
            },

            onRowSelect:function (componentId, eventName, isChecked) {
                this.trigger("itemClicked", isChecked);
            },

            selectRow:function (checked) {
                if (checked) {
                    this.$el.addClass("selected");
                }
                else {
                    this.$el.removeClass("selected");
                }
                this.uiComponents.selectCheckBox.setCheckedState(checked);
            },

            setError: function(attr, isError, msg) {
                if (attr === this.model.KEYS.NAME) {
                    this.uiComponents.name.setError(isError, msg);
                }
            },

            onSaveInvalid: function(model, errors) {
                if (_.has(errors, this.model.KEYS.NAME)) {
                    var errorMsg = LE.translator.translate(errors[this.model.KEYS.NAME]);
                    this.setError(this.model.KEYS.NAME, true, errorMsg);
                }
            },

            _getCategoryName: function() {
                return this.model.get(this.model.KEYS.NAME);
            },

            _enableNavigation: function(enabled) {
                this.uiComponents.host$.setEnabledAll(enabled);
            },

            onError: function() {
                return true;
            }


        });

    });

    return CategoriesGridRowView;
});
